import React from 'react';
import { Link } from 'react-router-dom';

const Documentation = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center mb-8">
          <Link to="/" className="text-gray-600 hover:text-indigo-600">
            Back to Home
          </Link>
        </div>

        <h1 className="text-3xl font-bold text-gray-900 mb-6">EventsAwa Documentation</h1>

        <div className="space-y-8">
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Introduction</h2>
            <p className="text-gray-600">
              EventsAwa is a comprehensive event management platform designed to streamline
              the planning, organization, and execution of events. This documentation provides
              detailed information about the platform's features, usage guidelines, and technical
              specifications.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Core Features</h2>
            <div className="space-y-4">
              <div className="border-l-4 border-indigo-500 pl-4">
                <h3 className="font-semibold text-gray-700">Event Management</h3>
                <ul className="list-disc list-inside text-gray-600">
                  <li>Create and manage events with detailed information</li>
                  <li>Track event expenses and budget</li>
                  <li>Manage event attendance and registrations</li>
                  <li>Generate analytics and reports</li>
                </ul>
              </div>

              <div className="border-l-4 border-indigo-500 pl-4">
                <h3 className="font-semibold text-gray-700">User Management</h3>
                <ul className="list-disc list-inside text-gray-600">
                  <li>Role-based access control (Admin, Organizer, Participant)</li>
                  <li>Account management and settings</li>
                  <li>Account deactivation/reactivation</li>
                </ul>
              </div>

              <div className="border-l-4 border-indigo-500 pl-4">
                <h3 className="font-semibold text-gray-700">Analytics & Reporting</h3>
                <ul className="list-disc list-inside text-gray-600">
                  <li>Event attendance tracking</li>
                  <li>Expense analytics</li>
                  <li>Device analytics</li>
                  <li>Custom reports</li>
                </ul>
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Getting Started</h2>
            <div className="space-y-4">
              <div className="border-l-4 border-indigo-500 pl-4">
                <h3 className="font-semibold text-gray-700">Registration</h3>
                <p className="text-gray-600">
                  Register for an account through our registration process. You'll need to
                  provide basic information and verify your email address.
                </p>
              </div>

              <div className="border-l-4 border-indigo-500 pl-4">
                <h3 className="font-semibold text-gray-700">Creating Your First Event</h3>
                <p className="text-gray-600">
                  Once registered, you can create your first event by providing event details,
                  setting budget parameters, and configuring attendance settings.
                </p>
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">API Documentation</h2>
            <p className="text-gray-600">
              For developers looking to integrate EventsAwa into their systems, our REST API
              provides endpoints for managing events, users, and analytics. API documentation
              is available in our developer portal.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Support & Resources</h2>
            <div className="space-y-4">
              <div className="border-l-4 border-indigo-500 pl-4">
                <h3 className="font-semibold text-gray-700">Help Center</h3>
                <p className="text-gray-600">
                  Visit our help center for detailed guides, tutorials, and FAQs.
                </p>
              </div>

              <div className="border-l-4 border-indigo-500 pl-4">
                <h3 className="font-semibold text-gray-700">Contact Support</h3>
                <p className="text-gray-600">
                  Reach out to our support team through the contact form in the help center.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Documentation;
